import { createReducer } from 'redux-act';
import * as actions from '#app/actions/account';
import { ModelHelper } from 'finhelper';
import type { AccountFormData } from '#app/pages/Relations/Accounts/types/accountForm';
import type { UserAccountsList } from '#app/types/account';

export interface AccountState {
  modalVisible: boolean;
  form: AccountFormData | Record<string, unknown>;
  availableTypes: number[];
  accounts: UserAccountsList | undefined;
  accountLoading: boolean;
}

const initialState: AccountState = {
  modalVisible: false,
  form: {},
  availableTypes: [],
  accounts: [],
  accountLoading: true,
};

interface UserAccountsResponse {
  result?: string;
  data?: UserAccountsList;
}

const setAccountModalVisible = (state: AccountState, bool: boolean): AccountState => ({
  ...state,
  modalVisible: bool,
});

const setAccountForm = (state: AccountState, form: AccountFormData | null): AccountState => {
  return {
    ...state,
    form: form ?? {},
  };
};

const setAvailableTypes = (state: AccountState, availableTypes: number[]): AccountState => ({
  ...state,
  availableTypes: availableTypes,
});

const handleUserAccounts = (state: AccountState, response: UserAccountsResponse): AccountState => {
  if (typeof response === 'object' && response.result === 'success') {
    ModelHelper.accounts = response.data as typeof ModelHelper.accounts;
    return {
      ...state,
      accounts: response.data,
      accountLoading: false,
    };
  } else {
    return {
      ...state,
      accountLoading: false,
    };
  }
};

export default createReducer<AccountState>(
  {
    [actions.setAccountModalVisible.getType()]: setAccountModalVisible,
    [actions.setAccountForm.getType()]: setAccountForm,
    [actions.setAvailableTypes.getType()]: setAvailableTypes,
    [actions.handleUserAccounts.getType()]: handleUserAccounts,
  },
  initialState
);
